module.exports = __webpack_public_path__ + "img/logbg.992cbe32.jpg";